export default __webpack_public_path__ + "static/media/cycle-icon.20864d7b.svg";